import React from 'react';
import { Modal, Table, Typography } from 'antd';

const { Text } = Typography;

const ParameterWeightsModal = ({ visible, onCancel, aggregatedWeightsData }) => {
  const healthSystemKeys = [
    "neurological",
    "cardiovascular",
    "respiratory",
    "metabolic",
    "filtration",
    "musculoskeletal",
    "immune"
  ];

  const columns = [
    {
      title: 'Parameter Name',
      dataIndex: 'displayName',
      key: 'displayName',
      fixed: 'left',
      width: 200,
      ellipsis: true,
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      width: 150,
      ellipsis: true,
    },
    {
      title: 'Overall Clinical Significance Weight',
      dataIndex: 'overall_clinical_significance_weight',
      key: 'overall_clinical_significance_weight',
      width: 150,
      align: 'center',
      render: (weight) => weight !== undefined ? `${weight}%` : 'N/A',
    },
  ];

  healthSystemKeys.forEach(systemKey => {
    const systemName = systemKey.charAt(0).toUpperCase() + systemKey.slice(1);
    columns.push({
      title: systemName,
      children: [
        {
          title: 'S',
          dataIndex: ['systems', systemKey, 'S'],
          key: `${systemKey}_S`,
          width: 70,
          align: 'center',
          render: (weight) => weight !== undefined ? `${weight}%` : '-',
        },
        {
          title: 'F',
          dataIndex: ['systems', systemKey, 'F'],
          key: `${systemKey}_F`,
          width: 70,
          align: 'center',
          render: (weight) => weight !== undefined ? `${weight}%` : '-',
        },
        {
          title: 'R',
          dataIndex: ['systems', systemKey, 'R'],
          key: `${systemKey}_R`,
          width: 70,
          align: 'center',
          render: (weight) => weight !== undefined ? `${weight}%` : '-',
        },
      ],
    });
  });

  // The data for the table needs to be an array of objects.
  // The `aggregatedWeightsData` is expected to be an object where keys are parameter keys
  // and values are the parameter config objects.
  const tableDataSource = aggregatedWeightsData 
    ? Object.values(aggregatedWeightsData).map(param => ({ ...param, key: param.key || param.displayName })) 
    : [];

  return (
    <Modal
      title="Parameter Weight Configuration Details"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="90vw" // Use a large portion of the viewport width
      style={{ top: 20 }} // Keep modal near the top
      bodyStyle={{ maxHeight: '85vh', overflowY: 'auto' }} // Make modal body scrollable
    >
      <Table
        columns={columns}
        dataSource={tableDataSource}
        bordered
        size="small"
        pagination={{ pageSize: 50 }} // Or false to show all
        scroll={{ x: 'max-content' }} // Enable horizontal scrolling
        sticky // For sticky headers
      />
      <Text type="secondary" style={{ marginTop: 16, display: 'block' }}>
        Note: 'S' denotes Structure, 'F' denotes Function, 'R' denotes Risk. Weights are percentages.
      </Text>
    </Modal>
  );
};

export default ParameterWeightsModal;
